import {FormBuilder} from '@angular/forms';
import {CustomMapLayer} from '../model/layers';
import {Layer, LayerType} from './layer';
import {GeospatialFilterStore} from '../api/geospatial-filter.store';

export class CustomLayer extends Layer {
    private config: CustomMapLayer;

    constructor(
        public fb: FormBuilder,
        public geospatialFilterStore: GeospatialFilterStore,
        private customLayerConfig: CustomMapLayer,
        public expanded: boolean = false,
    ) {
        super(
            customLayerConfig.label,
            LayerType.CUSTOM,
            fb,
            geospatialFilterStore,
            !customLayerConfig.disabled,
            expanded,
        );
        this.config = customLayerConfig;
    }

    /** Toggle layer expand/collapse status, in control panel? */
    toggleLayer(): void {
        this.expanded = !this.expanded;
    }

    getDescription(): string {
        return this.config.description;
    }
}
